export class storestationIdlocationidAction {
    static readonly type = '[stationidlocationid] stationidlocationid';

    constructor(public payload: any) {
    }
}
export class storeNursestationIdAction {
    static readonly type = '[stationid] stationid';

    constructor(public payload: any) {
    }
}
export class storeLocIdAction {
    static readonly type = '[locaid] locaid';

    constructor(public payload: any) {
    }
}